import React, { useState, KeyboardEvent, ChangeEvent } from "react";
import { Form } from "react-bootstrap";

export interface AddTagsForPurchaseRequestProps {
  label?: string;
  placeholder?: string;
  value: string[];
  onChange: (tags: string[]) => void;
  disabled?: boolean;
}

const AddTagsForPurchaseRequest: React.FC<AddTagsForPurchaseRequestProps> = ({
  label = "Add Tags",
  placeholder = "Enter tags",
  value,
  onChange,
  disabled = false,
}) => {
  const [input, setInput] = useState("");

  const handleAdd = () => {
    const trimmed = input.trim();
    if (!trimmed) return;

    if (!value.includes(trimmed)) {
      onChange([...value, trimmed]);
    }

    setInput("");
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (!disabled) handleAdd();
    }
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInput(e.target.value);
  };

  const handleRemove = (tagToRemove: string) => {
    onChange(value.filter((tag) => tag !== tagToRemove));
  };

  return (
    <Form.Group>
      {label && <Form.Label className="mb-1">{label}</Form.Label>}

      <div className="position-relative">
        <Form.Control
          type="text"
          placeholder={placeholder}
          value={input}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          className="pe-5"
        />

        <button
          type="button"
          onClick={handleAdd}
          disabled={disabled}
          className="tag-add-btn-pr"
        >
          +
        </button>
      </div>

      {value && value.length > 0 && (
        <div className="mt-2 d-flex flex-wrap gap-2">
          {value.map((tag) => (
            <span
              key={tag}
              className="badge bg-light text-dark d-flex align-items-center rounded-2"
              style={{
                border: "1px solid #dee2e6",
                padding: "6px 10px",
                fontSize: "0.8rem",
              }}
            >
              <span style={{ marginRight: 6 }}>{tag}</span>

              <button
                type="button"
                onClick={() => handleRemove(tag)}
                style={{
                  border: "none",
                  background: "transparent",
                  padding: 0,
                  lineHeight: 1,
                  fontSize: "0.9rem",
                  cursor: "pointer",
                }}
              >
                ×
              </button>
            </span>
          ))}
        </div>
      )}

      <style>
        {`
        .tag-add-btn-pr {
          position: absolute;
          right: 6px;
          top: 50%;
          transform: translateY(-50%);
          
          width: 22px;
          height: 22px;
          border-radius: 50%;
          border: none;

          background: #dc3545;
          color: white;

          display: flex;
          align-items: center;
          justify-content: center;

          font-size: 14px;
          line-height: 1;
          padding: 0;
          cursor: pointer;
        }

        .tag-add-btn-pr:hover {
          background: #bb2d3b;
        }
        `}
      </style>
    </Form.Group>
  );
};

export default AddTagsForPurchaseRequest;
